export const initialArticle = {
  id: '',
  viewId: 0,
  author: {
    id: 0,
    name: '',
  },
  headline: '',
  description: '',
  publishedAt: '',
  themes: [],
  attachments: [],
  deals: [],
  parents: [],
  issuers: [],
  sectors: [],
  sections: [],
  industries: [],
  sectorOrIndustry: null,
  subsectorOrSubindustry: null,
  createdAt: '',
  updatedAt: '',
};

export const defaultArticleRelatedDataValue = {
  collection: [],
};
